<template lang="pug">
.search-not-found
	VueFeedback(type="no-result")
		template(slot="feedback-title") Oops!
		template(slot="feedback-content")
			p.sf-text Sorry, there is no search result for "{{ query }}".#[br]Please check the phrase you entered or try another one.
</template>
<script>
import VueFeedback from '@ui-common/vue-feedback';

export default {
	name: 'SearchNotFound',
	props: {
		query: {
			required: true,
			type: String
		}
	},
	components: {
		VueFeedback
	}
};
</script>
<style src="@ui-common/vue-feedback/dist/vue-feedback.css"></style>
<style lang="css">
.search-not-found {
	margin-left: auto;
	margin-right: auto;
	max-width: 544px;
}
</style>
